import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneNumberComponent implements OnInit {
  @Input() phoneNumber: string;
  @Input() phoneLabel = '';

  isMobile = false;

  private readonly mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  ngOnInit(): void {
    this.updateMobileStatus();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.updateMobileStatus();
  }

  private updateMobileStatus(): void {
    this.isMobile = this.detectMobileDevice();
  }

  private detectMobileDevice(): boolean {
    return (
      this.mobileRegex.test(navigator.userAgent) || navigator.maxTouchPoints > 0
    );
  }
}
